module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6e89ac4b1f3ebf0838fc26c4c5a9e847.png";